import { render } from "./TabsandTextcards.vue?vue&type=template&id=622dd8ea&scoped=true"
import script from "./TabsandTextcards.vue?vue&type=script&lang=js"
export * from "./TabsandTextcards.vue?vue&type=script&lang=js"

import "./TabsandTextcards.vue?vue&type=style&index=0&id=622dd8ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622dd8ea"]])

export default __exports__